import React from 'react';

const Success = () => {
    return (
        <div>
            <h1>Paiement réussi</h1>
            <p>Merci pour votre commande. Votre paiement a été traité avec succès.</p>
        </div>
    );
};

export default Success;
